import { z } from "zod";

/** UI languages. German is the source language; English is the accommodation. */
export const LocaleSchema = z.enum(["de", "en"]);
export type Locale = z.infer<typeof LocaleSchema>;

export const UpdateLocaleRequest = z.object({ locale: LocaleSchema });
export type UpdateLocaleRequest = z.infer<typeof UpdateLocaleRequest>;
